import Map from '../components/Map';

export default {
  init () {
    window.APTIM.Map = Map()
    this.loadGoogleMapApi('https://maps.googleapis.com/maps/api/js?key=AIzaSyCOn0SFoBK40qxzunoYMksnK1NwLLqpaoo&callback=window.APTIM.Map.notify.mapLib.complete')
  },

  loadGoogleMapApi (src) {
    let ref = window.document.getElementsByTagName('script')[0]
    let script = window.document.createElement('script')
    script.src = src
    script.async = true
    ref.parentNode.insertBefore(script, ref)
  },
}
